import { useEffect, useState } from "react";
import { IoLockClosedOutline } from "react-icons/io5";
import { FaRegCheckCircle } from "react-icons/fa";
import { CiTrash, CiSettings } from "react-icons/ci";
import { HiOutlineHome } from "react-icons/hi2";
import { AiOutlineGlobal } from "react-icons/ai";
import { getAccessToken } from "../../storage/storage";
import axios from "axios";
import { getApiErrorMessage } from "../../utils/apiError";
import { ButtonLoader4 } from "../../components/ButtonLoader";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function TaskManager() {
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [options, setOptions] = useState([]);            // global tasks
  const [selectedGlobalTasks, setSelectedGlobalTasks] = useState([]); // only global tasks selection
  const [customTasks, setCustomTasks] = useState([]);    // always selected
  const [customTasksError, setCustomTasksError] = useState("");
  const [newCustomTask, setNewCustomTask] = useState("");

  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [taskLoading, setTaskLoading] = useState(false);
  const [propertyError, setPropertyError] = useState(false);

  const Navigate = useNavigate();

  /** Fetch Properties */
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/properties/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setProperties(res.data))
      .catch((err) => console.error("Error fetching properties:", err));
  }, [BASE_URL, token]);

  /** Fetch Global & Custom Tasks */
  // useEffect(() => {
  //   axios
  //     .get(`${BASE_URL}/api/global-task/`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((res) => setOptions(res.data))
  //     .catch((err) => console.error("Error fetching global tasks:", err));

  //   axios
  //     .get(`${BASE_URL}/api/custom-task/`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((res) => setCustomTasks(res.data))
  //     .catch((err) => console.error("Error fetching custom tasks:", err));
  // }, [BASE_URL, token]);

  

  /** Fetch tasks for selected property */
  // useEffect(() => {
  //   if (!selectedProperty) return;

  //   setSelectedGlobalTasks([]);

  //   axios
  //     .get(`${BASE_URL}/api/property-tasks/${selectedProperty.id}/`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((response) => {
  //       const propertyTasks = response.data.tasks || [];

  //       // Filter out any merged tasks that no longer exist
  //       const updatedOptions = options.filter(
  //         (opt) =>
  //           !opt.isMerged || propertyTasks.some((t) => t.task === opt.name)
  //       );

  //       // Add new merged tasks
  //       const mergedTasks = propertyTasks
  //         .filter((t) => !options.some((opt) => opt.name === t.task))
  //         .map((t) => ({ id: t.id, name: t.task, isMerged: true }));

  //       const finalOptions = [...updatedOptions, ...mergedTasks];
  //       setOptions(finalOptions);

  //       // Select tasks that match the property's tasks
  //       const matchedTasks = finalOptions.filter((task) =>
  //         propertyTasks.some((t) => t.task === task.name)
  //       );

  //       setSelectedGlobalTasks(matchedTasks);
  //     })
  //     .catch((error) => console.error("Error fetching property tasks:", error));
  // }, [selectedProperty, BASE_URL, token]);


  /** Fetch tasks (global + custom) for selected property */
  useEffect(() => {
    if (!selectedProperty) return;

    // fetch selected global tasks for property
    axios
      .get(`${BASE_URL}/api/selected-global-task/${selectedProperty.id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // API returns array of tasks: {id, name, selected:true/false}
        const globalTasks = res.data;
        setOptions(globalTasks); // all tasks
        setSelectedGlobalTasks(globalTasks.filter((t) => t.selected)); // preselected
      })
      .catch((err) =>
        console.error("Error fetching selected global tasks:", err)
      );

    // fetch custom tasks for property
    axios
      .get(`${BASE_URL}/api/custom-task/?property_id=${selectedProperty.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setCustomTasks(res.data);
        setCustomTasksError("");
      })
      .catch((err) => {
        console.error("Error fetching custom tasks:", err);
        setCustomTasks([]);
        setCustomTasksError(getApiErrorMessage(err, "Couldn't load custom tasks."));
      });
  }, [selectedProperty, BASE_URL, token]);


  /** Select / Deselect all global tasks */
  const selectAllGlobalTasks = () => {
    setSelectedGlobalTasks(options);
  };
  const deselectAllGlobalTasks = () => {
    setSelectedGlobalTasks([]);
  };

  /** Toggle one global task */
  const toggleGlobalTask = (task) => {
    setSelectedGlobalTasks((prev) =>
      prev.some((t) => t.id === task.id)
        ? prev.filter((t) => t.id !== task.id)
        : [...prev, task]
    );
  };

  /** Add Custom Task */
  const addCustomTask = async () => {
    if (!newCustomTask.trim() || customTasks.some((t) => t.name === newCustomTask)) return;

    try {
      const res = await axios.post(
        `${BASE_URL}/api/custom-task/`,
        // `${BASE_URL}/api/custom-task/`,
        { name: newCustomTask ,
          property_id:selectedProperty.id
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setCustomTasks([...customTasks, res.data]);
      setNewCustomTask("");
    } catch (err) {
      console.error("Error adding custom task:", err);
    }
  };

  /** Delete Custom Task */
  const removeCustomTask = async (task) => {
    try {
      await axios.delete(`${BASE_URL}/api/custom-task/${task.id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCustomTasks(customTasks.filter((t) => t.id !== task.id));
    } catch (err) {
      console.error("Error deleting custom task:", err);
    }
  };

  /** Final combined selected tasks for summary */
  const selectedTasks = [...selectedGlobalTasks, ...customTasks];

  /** Save Configuration */
  const assignTasks = async () => {
    if (!selectedProperty) {
      setPropertyError(true);
      return;
    }
    setPropertyError(false);

    const payload = {
      property_id: selectedProperty.id,
      global_task_ids: selectedGlobalTasks.map((t) => t.id),
      custom_task_ids: customTasks.map((t) => t.id),
    };

    try {
      setTaskLoading(true);
      const res = await axios.post(`${BASE_URL}/api/assign-tasks/`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        icon: "success",
        title: res.data.message || "Data Added Successfully",
        timer: 2000,
        showConfirmButton: false,
        position: "center",
      });
      Navigate("/stays");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title:
          err.response?.data?.non_field_errors ||
          err.response?.data?.message ||
          "Something went wrong!",
        timer: 2000,
        showConfirmButton: false,
        position: "center",
      });
    } finally {
      setTaskLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6 my-8">
      <div>
        <h1 className="text-2xl text-[#586989] font-bold">
          Property Task Configuration
        </h1>
        <p className="text-gray-600">
          Configure which tasks cleaners can perform for this property.
        </p>
      </div>

      {/* Property Selection */}
      <div className="flex flex-col gap-2 rounded-lg shadow-md bg-white">
        <div className="flex gap-2 items-center bg-transparent px-4 py-3">
          <CiSettings className="text-[#586989]" size={22} />
          <h2 className="text-lg font-semibold text-[#586989]">
            Select Property
          </h2>
        </div>
        <div className="px-4 pt-2 pb-3 flex flex-col gap-1">
          <label className="text-[#586989] text-base font-semibold">
            Choose Property *
          </label>
          <select
            value={selectedProperty ? selectedProperty.id : ""}
            onChange={(e) => {
              const selected = properties.find(
                (prop) => prop.id === parseInt(e.target.value)
              );
              setSelectedProperty(selected || null);
              setPropertyError(false);
            }}
            className={`bg-[#F3F3F5] px-3 outline-none h-[40px] rounded-lg opacity-80 cursor-pointer ${propertyError ? "border-red-500" : "border border-transparent"
              }`}
          >
            <option value="">Select a Property</option>
            {properties.map((property) => (
              <option key={property.id} value={property.id}>
                {property.name}
              </option>
            ))}
          </select>
          {propertyError && (
            <p className="text-red-500 text-sm ">Please select a property.</p>
          )}
        </div>
      </div>

      {/* Global Task Types */}
      <div className="flex flex-col rounded-lg shadow-md bg-white ">
        <div className="bg-[#FFF5CE] flex px-4 py-3 justify-between items-center rounded-t-lg">
          <div className="flex flex-col gap-1">
            <div className="flex gap-2 items-center">
              <AiOutlineGlobal  className="text-[#586989]" size={20} />
              <h2 className="text-lg font-semibold text-[#586989]">
                Platform Task Types
              </h2>
              <span className="text-sm font-semibold bg-gray-200 px-2 py-1 rounded-2xl text-[#586989]">Global</span>
            </div>
            <p className="text-gray-600 pl-7">
              Standard tasks available across all properties.
            </p>
          </div>
          {options.length > 0 && (
            <div className="flex gap-2">
              <button
                onClick={selectAllGlobalTasks}
                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100"
              >
                Select All
              </button>
              <button
                onClick={deselectAllGlobalTasks}
                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100"
              >
                Deselect All
              </button>
            </div>
          )}
        </div>
        <div className="space-y-3 px-4 py-2">
          {options.length > 0 ? (
            options.map((task) => (
              <label
                key={task.id}
                className={`flex items-center shadow-sm space-x-2 h-[40px] p-2 rounded-md border border-gray-300 outline-none opacity-80 ${selectedGlobalTasks.some((t) => t.id === task.id)
                  ? "bg-[#E8F1FF]"
                  : "bg-white"
                  }`}
              >
                <input
                  type="checkbox"
                  checked={selectedGlobalTasks.some((t) => t.id === task.id)}
                  onChange={() => toggleGlobalTask(task)}
                  className="w-4 h-4 accent-[#586989]"
                />
                <span>{task.name}</span>
              </label>
            ))
          ) : (
            <div className="m-2 p-2 text-center text-gray-500 bg-gray-50 rounded-md">
              No platform tasks available.
            </div>
          )}
        </div>
      </div>

      {/* Property Specific Tasks */}
      <div className="flex flex-col  rounded-lg shadow-md bg-white bg-white ">
        <div className="bg-[#FFF5CE] flex gap-2 px-4 py-3 justify-between items-start item-center rounded-t-lg">
          <div>
            <div className="flex gap-2 items-center">

              <FaRegCheckCircle className="text-[#586989]" size={18} />
              <h2 className="text-lg font-semibold text-[#586989] ">
                Property Specific Tasks
              </h2>
            </div>
            <p className="text-gray-600 pl-7">
              Add custom tasks unique to this property. These will only be
              available for this location.
            </p>
          </div>
        </div>

        <div className="flex px-4 py-2 gap-2">
          <input
            type="text"
            placeholder="Enter custom task name"
            value={newCustomTask}
            onChange={(e) => setNewCustomTask(e.target.value)}
            className="flex-1 p-3 border border-gray-300 outline-none opacity-80 bg-[#F3F3F5] rounded-md h-[40px]"
          />
          <button
            onClick={addCustomTask}
            className="bg-[#586989] text-white px-4 py-2 rounded-md "
          >
            + Add Task
          </button>
        </div>

        <div className="space-y-3 px-4 py-2 pt-1">
          {customTasksError ? (
            <div className="m-3 p-4 text-center text-[#DC2626] bg-gray-50 rounded-md">
              {customTasksError}
            </div>
          ) : customTasks.length > 0 ? (
            customTasks.map((task) => (
              <label
                key={task.id}
                className="flex justify-between shadow-sm items-center p-2  h-[40px] bg-[#E8F1FF] border border-gray-300 outline-none opacity-80 rounded-md"
              >
                <div className="flex items-center gap-2">
                <FaRegCheckCircle className="text-[#586989]" size={18} />
                  <span>{task.name}</span>
                </div>
                <button
                  onClick={() => removeCustomTask(task)}
                  className="text-red-600"
                >
                  <CiTrash className="w-5 h-5" />
                </button>
              </label>
            ))
          ) : (
            <div className="m-3 p-4 text-center text-gray-500 bg-gray-50 rounded-md">
              No custom tasks added yet
            </div>
          )}
        </div>
      </div>

      {/* Available Tasks Summary */}
      <div className="flex flex-col gap- rounded-lg shadow-md bg-white bg-white">
        <div className="bg-[#FFF5CE] flex gap-2 px-4 py-3 justify-between items-start item-center rounded-t-lg">
          <div>
            <div className="flex gap-2 items-center">
              <FaRegCheckCircle className="text-[#586989]" size={18} />
              <h2 className="flex gap-2 items-center text-lg font-semibold text-[#586989] flex gap-2">
                Available Tasks Summary
                <span className="text-sm bg-gray-200 px-2 py-1 rounded-2xl">
                  {selectedTasks.length}{" "}
                  {selectedTasks.length === 1 ? "task" : "tasks"} selected
                </span>
              </h2>
            </div>
            <p className="text-gray-600 pl-7">
              &#9432; These tasks will be available to cleaners when creating task
              sheets for this property.
            </p>
          </div>
        </div>

        <div className="px-4 py-3 grid grid-cols-2 gap-3">
          {selectedTasks.length > 0 ? (
            selectedTasks.map((task) => (
              <div
                key={task.id}
                className="border shadow-sm border-gray-300 bg-[#E8F1FF]  flex items-center justify-center p-2 rounded-2xl"
              >
                <span className="text-sm text-center">{task.name}</span>
              </div>
            ))
          ) : (
            <p className="text-gray-500 col-span-2 text-center py-4">
              No tasks selected
            </p>
          )}
        </div>

      </div>
      <div className="flex justify-end gap-3 p-4">
        <button
          onClick={() => Navigate("/stays")}
          className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={assignTasks}
          disabled={taskLoading || !selectedProperty}
          className="px-4 py-2 bg-[#586989] text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {taskLoading ? <ButtonLoader4 /> : "Save Configuration"}
        </button>
      </div>
    </div>
  );
}